import { render, staticRenderFns } from "./TranscribeSubtitlesToggle.vue?vue&type=template&id=f9b7fa04&scoped=true&"
import script from "./TranscribeSubtitlesToggle.vue?vue&type=script&lang=js&"
export * from "./TranscribeSubtitlesToggle.vue?vue&type=script&lang=js&"
import style0 from "./TranscribeSubtitlesToggle.vue?vue&type=style&index=0&id=f9b7fa04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b7fa04",
  null
  
)

export default component.exports